
import {getUserLogger} from '../api/getUserLogger';
import {setGetUserLoggerAction} from '../action';

const setGetUserLogger = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getUserLogger(params);

            if (data.status === 'success') {
                dispatch(setGetUserLoggerAction({
                    data: data.data,
                    countPage: data.countPage
                }));           
            }
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetUserLogger
}